import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "body__loading"
}
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  width: "20",
  height: "20",
  style: {"shape-rendering":"auto","display":"block"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "prepend__icon"
}
const _hoisted_5 = {
  key: 1,
  class: "body__text"
}
const _hoisted_6 = {
  key: 3,
  class: "append__icon"
}

import { ICommonButtonEmits, ICommonButtonProps } from "@/types/main";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonButton',
  props: {
    position: { default: "horizontal" },
    type: { default: "primary" },
    prepend: { type: Boolean },
    prependIcon: {},
    append: { type: Boolean },
    appendIcon: {},
    label: { default: "" },
    isDisabled: { type: Boolean },
    loading: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    icon: {}
  },
  emits: ["clicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const clickButton = () => {
  if (props.isDisabled || props.loading) return;
  emit("clicked");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-co-button", { 'icon-only': __props.iconOnly }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["body", [__props.type, __props.isDisabled ? 'disabled' : '', __props.loading ? 'loading' : '']]),
      onClick: clickButton
    }, [
      (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createStaticVNode("<g data-v-468db508><g transform=\"matrix(1,0,0,1,0,0)\" data-v-468db508><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" opacity=\"0.225001\" data-v-468db508></rect></g><g transform=\"matrix(0.7071067811865476,0.7071067811865476,-0.7071067811865476,0.7071067811865476,50,-20.710678118654755)\" data-v-468db508><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" opacity=\"0.350001\" data-v-468db508></rect></g><g transform=\"matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,100,0)\" data-v-468db508><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" opacity=\"0.475001\" data-v-468db508></rect></g><g transform=\"matrix(-0.7071067811865475,0.7071067811865476,-0.7071067811865476,-0.7071067811865475,120.71067811865476,49.99999999999999)\" data-v-468db508><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" opacity=\"0.600001\" data-v-468db508></rect></g><g transform=\"matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,100,100)\" data-v-468db508><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" opacity=\"0.725001\" data-v-468db508></rect></g><g transform=\"matrix(-0.7071067811865477,-0.7071067811865475,0.7071067811865475,-0.7071067811865477,50.000000000000014,120.71067811865476)\" data-v-468db508><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" opacity=\"0.850001\" data-v-468db508></rect></g><g transform=\"matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,7.105427357601002e-15,100)\" data-v-468db508><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" opacity=\"0.975001\" data-v-468db508></rect></g><g transform=\"matrix(0.7071067811865474,-0.7071067811865477,0.7071067811865477,0.7071067811865474,-20.710678118654755,50.000000000000014)\" data-v-468db508><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" opacity=\"0.100001\" data-v-468db508></rect></g></g>", 1)
            ]))]))
          ]))
        : (__props.iconOnly)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (__props.icon)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), {
                    key: 0,
                    size: 20
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, "+"))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (__props.prepend && __props.prependIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.prependIcon), { size: 20 }))
                  ]))
                : _createCommentVNode("", true),
              (__props.label)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.label), 1))
                : _renderSlot(_ctx.$slots, "default", { key: 2 }),
              (__props.append && __props.appendIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.appendIcon), { size: 20 }))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
    ], 2)
  ], 2))
}
}

})